const Capitalize = {
  install (Vue, options) {
    Vue.mixin({
      filters: {
        capitalize: function (string) {
          return string.charAt(0).toUpperCase() + string.slice(1)
        }
      }
    })
  }
}

export default Capitalize
